import React from "react";

const CupTable = () => {
  return (
    <>
      <section className="about-area pb-60 pt-60">
        <div className="container">
        <h2 className='pb-1' data-aos="fade-up" data-aos-delay="100">NASCAR XFINITY SERIES STATS</h2>
        <p className='pb-1 lh-base' data-aos="fade-up" data-aos-delay="100">NASCAR Xfinity Series Race Statistics: The NASCAR Xfinity Series was formerly known as the NASCAR Sportsman Division (1950-1967); NASCAR Late Model Sportsman Division (1968-1981); NASCAR Budweiser Late Model Sportsman Series (1982-1983); NASCAR Busch Grand National Series (1984-1994); NASCAR Busch Series Grand National Division (1995-2003); NASCAR Busch Series (2004-2007); NASCAR Nationwide Series (2008-2014)</p>
       
          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr style={{ width: "100%" }}>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "5%" }}>
                Races
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Champion
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Car Owner
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Champion's Crew Chief
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Rookie of the Year
                </th>
                <th scope="col"  style={{ textAlign: "center", width: "15%" }}>
                Most Popular Driver
                </th>
                <th scope="col" style={{ textAlign: "center", width: "15%" }}>
                Manufacturers' Championship
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2023</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Ryan Blaney</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Jonathan Hassler</td>
                <td style={{ textAlign: "center" }}>Ty Gibbs</td>
                <td style={{ textAlign: "center" }}></td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2022</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Joey Logano</td>
                <td style={{ textAlign: "center" }}>Roger Penske</td>
                <td style={{ textAlign: "center" }}>Paul Wolfe</td>
                <td style={{ textAlign: "center" }}>Austin Cindric</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>2021</td>
                <td style={{ textAlign: "center" }}>36</td>
                <td style={{ textAlign: "center" }}>Kyle Larson</td>
                <td style={{ textAlign: "center" }}>Rick Hendrick</td>
                <td style={{ textAlign: "center" }}>Cliff Daniels</td>
                <td style={{ textAlign: "center" }}>Chase Briscoe</td>
                <td style={{ textAlign: "center" }}>Chase Elliott</td>
                <td style={{ textAlign: "center" }}>Chevrolet</td>
              </tr>
          
            </tbody>
          </table>
          <h2 className='pt-5 pb-1' data-aos="fade-up" data-aos-delay="100">Past Champions:</h2>

          <table className="table  table-dark table-striped table-bordered border-light">
            <thead>
              <tr>
                <th scope="col" style={{ textAlign: "center" }}>
                Year
                </th>
                <th scope="col" style={{ textAlign: "center" }}>
                Driver Name
                </th>
              
              </tr>
            </thead>
            <tbody>
              <tr >
                <td style={{ textAlign: "center"}}>1980</td>
                <td style={{ textAlign: "center" }}>Tommy Ellis</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1981</td>
                <td style={{ textAlign: "center" }}>Morgan Shepherd</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1981</td>
                <td style={{ textAlign: "center" }}>Gene Glover</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1976</td>
                <td style={{ textAlign: "center" }}>Butch Lindley</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1972</td>
                <td style={{ textAlign: "center" }}>Butch Lindley</td>
                
              </tr>
              <tr >
                <td style={{ textAlign: "center"}}>1980</td>
                <td style={{ textAlign: "center" }}>Tommy Ellis</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1981</td>
                <td style={{ textAlign: "center" }}>Morgan Shepherd</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1981</td>
                <td style={{ textAlign: "center" }}>Gene Glover</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1976</td>
                <td style={{ textAlign: "center" }}>Butch Lindley</td>
                
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>1972</td>
                <td style={{ textAlign: "center" }}>Butch Lindley</td>
                
              </tr>
            
          
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default CupTable;
